import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Alternativ text saknas för denna bild',
    noAnswers: 'Inget svar-alternativ, klicka på nästa för att fortsätta.',
    placeholder: 'Vänligen specificera...',
    pleaseSelect: 'Vänligen välj...',
    rotateLandscape: 'Stäng av orienteringslåset på din telefon och vrid den till liggande läge för att fortsätta.',
    rotatePortrait: 'Vrid telefonen från liggande till stående läge för att fortsätta.',
    ir: {
      selectWebCam:
        'Välj webbkamera (om den är tillgänglig) eller klicka på "bläddra" för att ladda upp från din enhet',
      noWebCam: 'Ingen webbkamera upptäckt',
      accessCamUpload: 'FÅ TILLGÅNG TILL KAMERA / LADDA UPP',
      browse: 'BLÄDDRA',
      uploadPhoto: 'Ladda upp ett foto',
      instead: 'istället',
      capture: 'TA FOTO',
      somethingWrong: 'Något gick fel. Försök igen senare',
      couldntRead: 'Vi kunde inte läsa av koden!',
      couldntProcess: 'Vi kunde inte behandla din bild!',
      moveOn: 'Försök igen eller skicka in ditt foto och fortsätt',
      tryAgain: 'Var god försök igen',
      dataReceived: 'Informationen är mottagen!',
      enterManually: 'Försök igen eller ange informationen manuellt nedan',
      positionQR:
        'Placera QR-koden framför kameran så att den passar in i den röda ramen eller ladda upp den från din dator.',
      analyzing: 'Vi analyserar bilden, var god vänta',
      submit: 'LÄMNA IN',
      startOver: 'Börja om',
      allDone: 'Klart!',
      cantAnalyze:
        'Vi kunde inte återge den här bilden. Försök att skicka in igen eller välj ett mer generiskt bildformat (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Tyvärr stöder vi inte detta filformat. Ladda upp en bildtyp som stöds (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Ingen webbkamera upptäckt',
      uploadVideo: 'Ladda upp en video',
      skip: 'Hoppa över?',
      accessCamUpload: 'FÅ TILLGÅNG TILL KAMERA / LADDA UPP',
      browse: 'BLÄDDRA',
      instead: 'istället',
      or: 'eller',
      stopRecording: 'Stoppa inspelning',
      willBeStopped: 'Inspelningen kommer att stoppas efter 5 minuter',
      stopOnDone: 'Sluta spela in när du är klar!',
      record: 'SPELA IN',
      somethingWrong: 'Något gick fel. Försök igen senare',
      microphone: 'Mikrofon',
      camera: 'Webbkamera',
      selectMicrophone: 'Välj din mikrofon',
      selectCam: 'Välj din webbkamera',
      submit: 'LÄMNA IN',
      upload: 'LADDA UPP',
      playback: 'Uppspelning',
      stopPlayback: 'Stopp Uppspelning',
      startOver: 'Börja om',
      allDone: 'Klart!',
      alternativeRecordSpan: 'Vänligen ladda upp ett videoklipp från din dator.<br/>Alternativt kan du &nbsp;',
      alrenativeRecordHref: 'spela in filmen med en webbkamera.',
      cantAnalyze:
        'Uppmärksamma - vi kunde inte göra denna video. Försök att skicka in igen eller välj ett mer generiskt videoformat (MP4, M4V, WEBPM)',
      wrongFormat:
        'Tyvärr stöder vi inte detta filformat. Ladda upp en videotyp som stöds (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'VÄLJ',
      pleaseChoose: 'Välj',
      this: 'DETTA',
      one: 'denna',
      myChoice: 'Mitt VAL'
    },
    hm: {
      addComment: 'Lägg till en kommentar nedan',
      commentMandatoryPlaceHolder: 'Lägg till obligatorisk kommentar … ',
      commentOptionalPlaceHolder: 'Lägg till valfri kommentar … ',
      dragPin: 'Dra för att ändra position (klicka/tryck länge för precisionsfästa).',
      removePin: 'Dra utanför bilden för att ta bort.',
      editComment: 'Klicka/tryck på fäste för att redigera kommentar.',
      addPin: 'Dra fästet från panelen nedan och släpp det på den plats du önskar på bilden.',
      addPins: 'Dra fästena från panelen nedan och släpp dem på den plats du önskar på bilden. ',
      leavePins: (minPoints, maxPoints) => `Lämna minst ${minPoints} men högst ${maxPoints} fästen av varje sort.`,
      leavePinsPerPage: (minPoints, maxPoints) => `Lämna minst ${minPoints} men högst ${maxPoints} fästen.`,
      leavePinsWithOff: maxPoints =>
        `Lämna högst ${maxPoints} fästen av varje sort eller klicka på Nästa för att hoppa över.`,
      leavePinsPerPageWithOff: maxPoints => `Lämna högst ${maxPoints} fästen eller klicka på Nästa för att hoppa över.`,
      leavePinWithOff: 'Lämna högst 1 fäste av varje sort eller klicka på Nästa för att hoppa över.',
      leavePinPerPageWithOff: 'Lämna högst 1 fäste eller klicka på Nästa för att hoppa över.',
      leaveExactlyPin: 'Lämna 1 fäste av varje sort.',
      leaveExactlyPinPerPage: 'Lämna 1 fäste.',
      leaveExactlyPins: maxPoints => `Lämna ${maxPoints} fästen av varje sort.`,
      leaveExactlyPinsPerPage: maxPoints => `Lämna ${maxPoints} fästen. `,
      leaveComment: 'Skriv under bilden för att lämna en kommentar. ',
      noAnswers: 'Inget svarsalternativ, klicka på Nästa för att fortsätta.',
      outOfPins: 'Du har slut på fästen',
      pinsBehavior: 'När du rör dig över bilden ser du områden som kommer att framhävas med en enda nålsläpp.',
      clusters: 'Du kommer bara att kunna placera nålar i dessa framhävda områden.',
      contentAware: 'Du kan släppa nålar inom eller utanför de framhävda områdena.'
    },
    mp: {
      expand_note: 'Håll muspekaren över eller klicka på bild(er) för att expandera',
      rb_note: rows => `Välj endast 1 per artikel${rows ? ' nedan' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Kryssa i alla giltiga alternativ:'
        } else if (min === max) {
          return `Välj ${min} ${min !== 1 ? 'valfritt valfria' : 'endast'} svar per artikel${rows ? ' nedan' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Välj minst ${min} ${min !== 1 ? 'valfri' : 'svar'} men inte fler än ${max} per artikel${
            rows ? ' nedan' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Vänligen välj minst ${min} ${min !== 1 ? 'valfri' : 'svar'} per artikel${rows ? ' nedan' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Välj inte fler än ${max} ${max !== 1 ? 'valfri' : 'svar'} per artikel${rows ? ' nedan' : ''}:`
        } else {
          return 'Kryssa i alla giltiga alternativ:'
        }
      }
    },
    sh: {
      note: 'Klicka på en produkt för att zooma in och lägg till i din virtuella varukorg om du vill köpa den i butiken',
      amazonNote: 'Klicka på en produkt för att zooma in och lägga till i din virtuella kundvagn.',
      fullCart: 'Din kundvagn är full!',
      qty: 'KVANTITET',
      addToCart: 'LÄGG TILL I KUNDVAGN',
      each: 'vardera',
      items: 'föremål ',
      deleteFromCart: 'TA BORT',
      emptyCard: 'Din kundvagn är tom',
      total: 'Kundvagn',
      clearCart: 'Rensa kundvagn',
      backToStore: 'Tillbaka till butik',
      na: 'Inget av ovan',
      next: 'NÄSTA',
      maxCartCountError: max => `Lägg inte till fler än ${max} produkter i din varukorg`,
      scrollError: `Vänligen bläddra helt åt vänster och höger för att fortsätta i undersökningen. `,
      maxSpentError: max => `Spendera inte mer än ${max}.`,
      maxProductCountError: max => `Lägg inte till mer än en mängd ${max} i din varukorg för varje produkt.`
    },
    rb: {
      note: 'Vänligen välj endast 1 objekt:'
    },
    vo: {
      note: 'Titta på hela videon'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Vänligen välj ${min !== 1 ? 'valfria' : 'endast'} ${min} objekt:`
        } else if (min > 0 && max < 5000) {
          return `Vänligen välj minst ${min} objekt men inte fler än ${max} per rad:`
        } else if (5000 === max && min > 0) {
          return `Vänligen välj minst ${min} objekt:`
        } else if (0 === min && max < 5000) {
          return `Vänligen välj inte fler än ${max} objekt:`
        } else {
          return 'Kryssa i alla giltiga alternativ:'
        }
      }
    },
    oe: {
      na: 'Inte tillämpbar',
      note: (min, max, optional) => {
        if (min === max) {
          return `Vänligen skriv ${1 !== min ? 'valfria' : 'exakt'} ${min} character${1 === min ? 's' : ''}${
            optional ? ' (frivilligt)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Vänligen ange minst ${min} tecken${1 !== min} men inte fler än ${max}${
            optional ? ' (frivilligt)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Vänligen ange minst ${min} tecken${optional ? ' (frivilligt)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Vänligen ange högst ${max} tecken${optional ? ' (frivilligt)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Fyll i följande fält:'
    },
    mx: {
      note: 'Vänligen flytta de markerade reglagen för att fortsätta',
      dragSlider: 'Dra till vänster eller höger för att svara'
    },
    psc: {
      dragLeftRight: 'Dra till vänster eller höger för att svara'
    },
    ps: {
      note: value => `Vänligen fördela återstående ${value} mellan objekten nedan`,
      allDone: 'Klart!',
      total: `Total:`,
      dragSlider: 'Dra till vänster eller höger för att svara'
    },
    cx: {
      note: 'Öppna menyn och börja skriva in ditt svar för att autoscrolla eller välja det manuellt'
    },
    ro: {
      note: 'Dra upp eller ner för att ändra ordningen:'
    },
    aro: {
      note: 'Vänligen välj en sak per par.'
    },
    md: {
      note1: 'Klicka/tryck på objektet du vill välja först<br/>Klicka/tryck igen för att ta bort valet.',
      note2: 'Klicka/tryck nu på objektet du vill välja sist<br/>Klicka/tryck igen för att ta bort valet.',
      note3: 'Tack! Fortsätt till nästa fråga eller<br/>klicka/tryck på omarkerade objekt för att börja om.'
    },
    wd: {
      note: 'Se till att varje efterföljande värde är större än det föregående värdet.'
    },
    emd: {
      note: 'Titta på hela videon',
      noAnswers: 'Inget svar-alternativ, klicka på nästa för att fortsätta.',
      start: 'Klicka och håll ner för att starta',
      resume: 'Klicka och håll ner för att återuppta',
      continue: 'Du är klar! <br /> Klicka på Nästa för att fortsätta',
      continueMobile: 'Du är klar! <br /> Klicka HÄR för att fortsätta',
      training: {
        session: 'Utbildningssession',
        note: 'Var god och avsluta träningen',
        moveLeft: 'Drag nummerskivan hela vägen till vänster',
        moveBottom: 'Drag nummerskivan hela vägen till botten',
        moveRight: 'Drag nu nummerskivan hela vägen till höger',
        moveTop: 'Drag nu nummerskivan hela vägen upp till toppen.',
        success: 'Bra jobbat!'
      }
    },
    sft: {
      noAnswers: 'Inget svar-alternativ, klicka på nästa för att fortsätta.',
      note: 'Svara så snabbt du kan med svaret som intuitivt känns rätt',
      finish: 'Du är helt klar! <br />Klicka på Nästa för att fortsätta',
      training: {
        start:
          '<p>Denna fråga kommer snabbt att visa dig olika ord och kommer att kräva din koncentration. ' +
          'Du kommer att behöva reagera snabbt för att svara. </p> <p>Är du redo att träna?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Tryck på "{buttonLeft}"`
            : (mouse ? `Klicka på "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Tryck på "{keyBtnLeft}"-tangenten` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Tryck på "{buttonRight}"`
            : (mouse ? `Klicka på "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Tryck på "{keyBtnRight}"-tangenten` : ''),
        fail: () => 'För långsamt',
        success: () => 'Fantastiskt!',
        finish: () =>
          '<p><strong> Utmärkt!</strong></p><p>Se till att du inte <br />' +
          'blir distraherad inom<br/> de närmaste 2-3 minuterna</p><p>Klicka på Nästa för att starta när du är klar. </p>'
      },
      buttons: {
        start: 'Starta',
        yesno: {
          left: 'Ja',
          right: 'Nej'
        },
        matches: {
          left: 'Matchar',
          right: 'Ingen matchning'
        },
        fits: {
          left: 'Passar',
          right: 'Passar inte'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
